// extracted by css-extract-rspack-plugin
export default {"leftSlot__box":"src-domain-components-resources-list-filters-ResourcesListFilters-module__leftSlot__box-oFiTNf","leftSlotBox":"src-domain-components-resources-list-filters-ResourcesListFilters-module__leftSlot__box-oFiTNf","listView__leftSlotClassName":"src-domain-components-resources-list-filters-ResourcesListFilters-module__listView__leftSlotClassName-pp6J3K","listViewLeftSlotClassName":"src-domain-components-resources-list-filters-ResourcesListFilters-module__listView__leftSlotClassName-pp6J3K"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"leftSlot__box\":\"src-domain-components-resources-list-filters-ResourcesListFilters-module__leftSlot__box-oFiTNf\",\"leftSlotBox\":\"src-domain-components-resources-list-filters-ResourcesListFilters-module__leftSlot__box-oFiTNf\",\"listView__leftSlotClassName\":\"src-domain-components-resources-list-filters-ResourcesListFilters-module__listView__leftSlotClassName-pp6J3K\",\"listViewLeftSlotClassName\":\"src-domain-components-resources-list-filters-ResourcesListFilters-module__listView__leftSlotClassName-pp6J3K\"}";
        // 1792611263200
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  